import { RxCollection, RxCollectionCreator, RxDocument, RxJsonSchema } from "rxdb"
import { IssuesOnItemAction } from "src/util/types/dataModels/issue"

//region Types

export type IssueOnItemActionsCollection = RxCollection<IssuesOnItemAction>

export type IssueOnItemActionsDocument = RxDocument<IssuesOnItemAction>

//endregion

/**
 * Schema for issue on item actions collections
 */
export const issueOnItemActionsSchema: RxJsonSchema<IssuesOnItemAction> = {
  title: "IssueOnItem Actions schema",
  description: "Collection of all Actions for an Issue On Item",
  version: 0,
  primaryKey: "id",
  type: "object",
  keyCompression: true,
  properties: {
    id: { type: "string", maxLength: 36, uniqueItems: true },
    created_dt: { type: "string", maxLength: 64 },
    updated_dt: { type: "string", maxLength: 64 },
    text: { type: "string", maxLength: 2048 },
    time_estimate: { type: "string" },
    isolation_required: { type: "boolean" },
    shutdown_required: { type: "boolean" },
    procedure_step_bool: { type: "string", maxLength: 36 }, // UUID
    procedure_step_numeric: { type: "string", maxLength: 36 }, // UUID
    procedure_step_select: { type: "string", maxLength: 36 }, // UUID
    procedure_step_photo: { type: "string", maxLength: 36 }, // UUID
    procedure_step_verify: { type: "string", maxLength: 36 }, // UUID
    issue: { ref: "issue_on_item", type: "string", maxLength: 36 }, // UUID
  },
  required: ["id", "text", "issue"],
  indexes: ["issue", "updated_dt"],
}

/**
 * A collection creator that can be passed to the database when setting up collections
 */
export const issueOnItemActionsCollectionCreator: RxCollectionCreator = {
  schema: issueOnItemActionsSchema,
}
